var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 0.666504C3.95121 0.666504 0.667969 3.94975 0.667969 7.99984C0.667969 12.0499 3.95121 15.3332 8.0013 15.3332C12.0514 15.3332 15.3346 12.0499 15.3346 7.99984C15.3346 3.94975 12.0514 0.666504 8.0013 0.666504ZM8.0013 3.99984C7.63311 3.99984 7.33463 4.29831 7.33463 4.6665C7.33463 5.03469 7.63311 5.33317 8.0013 5.33317H8.00797C8.37616 5.33317 8.67463 5.03469 8.67463 4.6665C8.67463 4.29831 8.37616 3.99984 8.00797 3.99984H8.0013ZM8.66797 7.33317C8.66797 6.96498 8.36949 6.6665 8.0013 6.6665C7.63311 6.6665 7.33463 6.96498 7.33463 7.33317V11.3332C7.33463 11.7014 7.63311 11.9998 8.0013 11.9998C8.36949 11.9998 8.66797 11.7014 8.66797 11.3332V7.33317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleFilled);
export default __webpack_public_path__ + "static/media/information-circle-filled.6ada20ac0e013980fdcaaefe6d81b554.svg";
export { ForwardRef as ReactComponent };